import React from 'react';
import AffaireCard from './AffaireCard';

/** La grille des affaires, avec ses états de chargement, d'erreur et de vide. */
export default function GrilleAffaires({ donnees, chargement, erreur, onEffacer }) {
  if (erreur && !donnees) {
    return <p className="zk-aff-message" role="alert">{erreur}</p>;
  }
  if (!donnees) {
    return (
      <div className="zk-aff-grille" aria-busy="true" aria-label="Chargement des affaires">
        {Array.from({ length: 8 }, (_, i) => <div key={i} className="zk-aff-carte fantome" />)}
      </div>
    );
  }
  if (!donnees.annonces.length) {
    return (
      <div className="zk-aff-message">
        <p>Aucune bonne affaire avec ces critères en ce moment.</p>
        {onEffacer && <button type="button" onClick={onEffacer}>Effacer les filtres</button>}
      </div>
    );
  }
  return (
    <div className={`zk-aff-grille${chargement ? ' recharge' : ''}`} aria-busy={chargement}>
      {donnees.annonces.map((a) => <AffaireCard key={a.id} a={a} />)}
    </div>
  );
}
